import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import LatestUpdates from "./components/LatestUpdates";
import HotRecommend from "./components/HotRecommend";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSeo({
    title: "芭乐视频-多元化高清视频内容与热门影片聚合",
    description:
      "芭乐视频为您提供丰富的视频资源，涵盖电影、电视剧、动漫等多种类别，用户可轻松浏览并发现热门影视内容，畅享多样化视听体验。",
    keywords: "芭乐视频,高清视频,电影,电视剧,动漫,免费在线观看,影视平台",
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryShortcuts />
      <LatestUpdates />
      <HotRecommend />
      <SiteIntro />
    </div>
  );
}